import styled from "@emotion/styled";

const EntityBadge = styled.span(({ theme }) => ({
  ...theme.fonts.body,
  backgroundColor: theme.colors.gray10,
  borderRadius: theme.borderRadius.xs,
  display: "inline-block",
  letterSpacing: ".02em",
  fontWeight: "bold",
  fontSize: theme.fontSizes.xxxs,
  margin: 0,
  padding: ".05em .5em",
  textDecoration: "none",
  width: "max-content",
  textTransform: "capitalize",
  span: {
    opacity: ".75",
  },
}));

export { EntityBadge };
